import axios from 'axios';
import errorManager from '@/rollbar.js';

function findH2OParam(pname, value = false) {
  const elem = pname && document.getElementById(pname);
  if (elem) {
    return value ? elem.value : elem;
  } else {
    console.warn('H2OIntegration.checkConnection: unable to find ', pname, ' element on page!');
    return null;
  }
}

const cs = function () {
  return findH2OParam('connection-status');
};
const checkingBadge = function () {
  return findH2OParam('checking-badge');
};
const connErrorBadge = function () {
  return findH2OParam('conn-error-badge');
};
const connSuccessBadge = function () {
  return findH2OParam('conn-success-badge');
};
const incompleteCredBadge = function () {
  return findH2OParam('incomplete-credentials-badge');
};
const context = function () {
  return findH2OParam('value_string_h2o_integration_context', true);
};

const host = function () {
  return findH2OParam('value_string_h2o_integration_host', true);
};
const username = function () {
  return findH2OParam('value_string_h2o_integration_username', true);
};
const password = function () {
  return findH2OParam('value_string_h2o_integration_password', true);
};

const checkStatusLestener = function () {
  if (host() && username() && password() && context()) {
    $(connErrorBadge()).hide();
    $(connSuccessBadge()).hide();
    $(incompleteCredBadge()).hide();
    $(checkingBadge()).show();
    checkConnection();
  } else {
    $(connErrorBadge()).hide();
    $(connSuccessBadge()).hide();
    $(checkingBadge()).hide();
    $(incompleteCredBadge()).show();
  }
};

const checkConnectionLestener = function () {
  if (context() && cs() && host() && password() && username()) {
    let url = Utils.addGetParam('/it/parameters_configs/check_h20_integration?mode=L&forceLogin=true', 'username', username());
    url = Utils.addGetParam(url, 'password', password());
    url = Utils.addGetParam(url, 'host', host());
    axios({
      method: 'get',
      url: url,
      headers: {
        'Content-type': 'application/json',
      },
    })
      .then((response) => {
        $(connErrorBadge()).hide();
        $(checkingBadge()).hide();
        $(incompleteCredBadge()).hide();
        $(connSuccessBadge()).show();
      })
      .catch(() => {
        $(checkingBadge()).hide();
        $(incompleteCredBadge()).hide();
        $(connSuccessBadge()).hide();
        $(connErrorBadge()).show();
      });
  }
};

const checkStatus = function () {
  try {
    checkStatusLestener();
  } catch (e) {
    errorManager(e);
  }
};

const checkConnection = () => {
  try {
    checkConnectionLestener();
  } catch (e) {
    errorManager(e);
  }
};

const init = function () {
  try {
    $(document).on('change', '[id*="value_string_h2o_integration_"]', checkStatus);
  } catch (e) {
    errorManager(e);
  }
};

window.H2oIntegration = {
  init: init,
  checkConnection: checkConnection,
  checkStatus: checkStatus,
};
